import React from 'react';
import './Introduction.css';
import { Typography, Button } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';

import profile from '../img/Bennett_profile_transparent50.png';
import resume from '../img/Resume 2022 Bennett Oh.pdf'

export default function Introduction() {
  return (
    <section className="intro">
      <div>
        <img src={profile} className="profile-pic" />
      </div>
      <div className="card">
        <h1 className="intro-hello">Hello!</h1>
        <Typography>
          I'm Bennett Oh, a Software Engineer at Microsoft! I'm a full-stack developer with a passion for learning and building things.
        </Typography>
        <br />
        <Button
          variant="outlined"
          color="primary"
          endIcon={<ArrowForward />}
          onClick={() => window.open(resume, "_blank")}>
          View my Resume
        </Button>
      </div>
    </section >
  );
}